// extracted by mini-css-extract-plugin
module.exports = {"details":"project-details-module--details--2c6aR","html":"project-details-module--html--wTfQT","featured":"project-details-module--featured--2xkfL"};